module.exports = __webpack_public_path__ + "static/media/AimeeMannCharmer.bea55ae0.mp4";